// src/components/Career.js
import React from "react";
import "../assets/styles/career.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import microsoft_logo from "../assets/images/microsoft_logo.svg";
import bits_pilani_logo from "../assets/images/bits-pilani.png";
import nyu_logo from "../assets/images/nyu-logo.png";
import meta_logo from "../assets/images/meta-logo.svg";
import SmallercontCareer from "./SmallerContCareer";

const careerTheme = createTheme({
  typography: {
    fontFamily: "Lato, sans-serif",
  },
});

export default function Career() {
  return (
    <ThemeProvider theme={careerTheme}>
      <SmallercontCareer>
        <div className="content-container">
          <section className="career-details">
            <div>
              {/* Removed theme toggle, just showing heading */}
              <div className="career-header">
                <h1>Career Log Graph</h1>
              </div>
              <h4>
                Author:{" "}
                <a
                  href="/"
                  rel="noopener noreferrer"
                  className="author-website-link"
                >
                  Abhishek Kadian
                </a>
              </h4>
              <h4>Date: Oct 2026</h4>
              <div style={{ maxWidth: "100%", overflowX: "hidden" }}>
                <Timeline
                  sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                      flex: 0.2,
                    },
                  }}
                >
                  {/* Timeline content remains unchanged */}
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      <div className="loggraph-side-text">2018 - Now</div>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent style={{ marginBottom: "40px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={meta_logo}
                          alt="Meta"
                          className="hide-on-mobile"
                          style={{
                            width: "60px",
                            height: "60px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="loggraph-text">
                          <h2>
                            Research Engineer @{" "}
                            <a
                              href="https://about.meta.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="loggraph-heading-website-link"
                            >
                              Meta
                            </a>
                          </h2>
                          <span style={{ color: "var(--sub-heading-color)" }}>
                            Jul 2025 - Now
                          </span>
                          <br />
                          I am part of the TBD Lab group where I work on Superintelligence.
                          <br />
                          <span style={{ color: "var(--sub-heading-color)" }}>
                            Mar 2023 - Jun 2025
                          </span>
                          <br />
                          I worked on{" "}
                          <a
                            href="https://llama.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Llama
                          </a>
                          {" "}.
                          <br />
                          <span style={{ color: "var(--sub-heading-color)" }}>
                            Sept 2021 - Feb 2023
                          </span>
                          <br />
                          I moved back to FAIR to work on vision-language models.
                          I worked on large-scale joint training on combined
                          language and vision data (
                          <a
                            href="https://arxiv.org/abs/2301.02280"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            DiHT
                          </a>
                          ).
                          <br />
                          <span style={{ color: "var(--sub-heading-color)" }}>
                            Aug 2020 - Aug 2021
                          </span>
                          <br />
                          I explored applied research. I worked on using vision
                          features for improving ads models.
                          <br />
                          <span style={{ color: "var(--sub-heading-color)" }}>
                            Jun 2018 - Jul 2020
                          </span>
                          <br />
                          I began my work at FAIR, focusing on Embodied AI. I
                          worked on the first version of{" "}
                          <a
                            href="https://aihabitat.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Habitat
                          </a>
                          . I also explored learning on lots of GPUs (
                          <a
                            href="https://arxiv.org/abs/1911.00357"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            DDPPO
                          </a>
                          ) and transferring learning to robots (
                          <a
                            href="https://arxiv.org/abs/1912.06321"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Sim2Real
                          </a>
                          ).
                          <br />
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      <div className="loggraph-side-text">2016 - 2018</div>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent style={{ marginBottom: "40px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={nyu_logo}
                          alt="NYU"
                          className="hide-on-mobile"
                          style={{
                            width: "60px",
                            height: "60px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="loggraph-text">
                          M.Sc. at{" "}
                          <a
                            href="https://en.wikipedia.org/wiki/New_York_University"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            New York University
                          </a>
                          . This is where I first got into Deep Learning. Some
                          of my projects from this time were{" "}
                          <a
                            href="https://drive.google.com/file/d/1dXl5Wgh2zbK-lPwmTlKCcsfYhSMTgW3p/view"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Iteratively Trained World Models
                          </a>
                          ,{" "}
                          <a
                            href="https://arxiv.org/abs/2212.12667"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Visualizing Information Bottleneck
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://github.com/pytorch/examples/tree/main/fast_neural_style"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            fast-neural-style in PyTorch
                          </a>
                          .
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      <div className="loggraph-side-text">2014 - 2016</div>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent style={{ marginBottom: "40px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={microsoft_logo}
                          alt="Microsoft"
                          className="hide-on-mobile"
                          style={{
                            width: "60px",
                            height: "60px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="loggraph-text">
                          I was a Research Fellow at{" "}
                          <a
                            href="https://www.microsoft.com/en-us/research/lab/microsoft-research-india/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Microsoft Research India
                          </a>
                          , Bangalore. This is where I first worked in Machine
                          Learning. My focus was on{" "}
                          <a
                            href="https://www.microsoft.com/en-us/research/project/extreme-classification/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            Extreme Classification
                          </a>
                          .
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      <div className="loggraph-side-text">2010 - 2014</div>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                    </TimelineSeparator>
                    <TimelineContent style={{ marginBottom: "40px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={bits_pilani_logo}
                          alt="BITS Pilani"
                          className="hide-on-mobile"
                          style={{
                            width: "60px",
                            height: "60px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="loggraph-text">
                          B.E. in Computer Science from{" "}
                          <a
                            href="https://en.wikipedia.org/wiki/BITS_Pilani"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="loggraph-website-link"
                          >
                            BITS Pilani
                          </a>
                          , India. Here, I learnt the fundamentals of computers
                          and programming.
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              </div>
            </div>
          </section>
        </div>
      </SmallercontCareer>
    </ThemeProvider>
  );
}
